import { useEffect, useState, useRef } from 'react';
import { getQuote } from '../api/signup-service';

export default function useQuote({
  subscriptionTier,
  annual,
  quantity,
  couponCode = "",
  customerId = "",
}) {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const prevCouponCode = useRef(couponCode);

  useEffect(() => {
    async function fetchQuote() {
      setLoading(true);
      setError(null);

      try {
        const payload = {
          subscriptionTier,
          annual,
          quantity,
        };

        // Exclude quoteId if we're clearing a coupon code to create a new quote
        const isClearingCoupon = prevCouponCode.current && !couponCode;
        if (quote?.quoteId && !isClearingCoupon) {
          payload.quoteId = quote.quoteId;
        }
        
        if (couponCode) payload.couponCode = couponCode;
        if (customerId) payload.customerId = customerId;

        const quoteResponse = await getQuote(payload);
        setQuote(quoteResponse);
      } catch (err) {
        console.error('Failed to fetch quote', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    fetchQuote();
    prevCouponCode.current = couponCode;
  }, [subscriptionTier, annual, quantity, couponCode, customerId]);

  return { quote, loading, error };
}